import { getAccessToken } from "./AccessToken"

export function getHeaders() {
    // return { Authorization: 'Bearer ' + accessToken }
    let access_token = getAccessToken()
    let headers = {
        'x-access-token': access_token
    }
    return headers
}